
import { ReactNode, useEffect } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import AIChatBubble from '@/components/AIChatBubble';

interface ProtectedRouteProps {
  children: ReactNode;
}

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { isAuthenticated, isLoading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // If not loading and not authenticated, redirect to auth page
    if (!isLoading && !isAuthenticated) {
      navigate('/auth', { replace: true, state: { from: location } });
    }
  }, [isAuthenticated, isLoading, navigate, location]);

  // While loading, show loading state
  if (isLoading) {
    return (
      <div className="min-h-screen bg-brand-background flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-brand-primary"></div>
      </div>
    );
  }

  // If not authenticated, show Navigate component to force redirect
  if (!isAuthenticated) {
    return <Navigate to="/auth" replace state={{ from: location }} />;
  }

  // If authenticated, render children
  const isSetupFlow = location.pathname.startsWith('/edit-memorial');

  return (
    <>
      {children}
      {!isSetupFlow && <AIChatBubble portalType="family" />}
    </>
  );
};

export default ProtectedRoute;
